<template>
  <!-- system 标准列表：对齐 police-record/index.vue 根容器（本页为 $crudCommon 生成式） -->
  <div>
    <avue-crud
      v-bind="bindVal"
      v-on="onEvent"
      v-model="form"
      :permission="permissionList"
      :page.sync="page"
    >
      <!-- 自定义列表多功能栏 -->
      <table-column-set :THIS_TO_PARENT="this" slot="menuRight" />
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          v-if="permission.param_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import crudmixins from "@/basic-common/mixins/crudmixins.js";
const mixin = new crudmixins({});
export default window.$crudCommon(
  {
    mixins: [mixin],
    data() {
      return {};
    },
    computed: {
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.param_add, false),
          viewBtn: this.vaildData(this.permission.param_view, false),
          delBtn: this.vaildData(this.permission.param_delete, false),
          editBtn: this.vaildData(this.permission.param_edit, false),
        };
      },
    },
    methods: {},
  },
  {
    //模块路径
    name: "system/param",
  }
);
</script>

<style></style>
